export default {
  targetTypeSelect: [
    { text: 'Content', value: 311 },
    { text: 'Links', value: 201 },
    { text: 'Keywords', value: 103 },
    { text: 'Custom', value: 0 },
    { text: 'Organic Traffic Value', value: 400 }
  ],
  typeColors: {
    311: 'green',
    201: 'blue',
    103: 'orange',
    0: 'blue-grey',
    400: 'cyan'
  },
  targetTypeText: {
    311: 'pages in SERP\'s',
    201: 'backlinks to site',
    103: 'keywords in 1st page',
    400: 'sum of CPC * estimated '
  },
  targetTypeItem: {
    311: 'page(s)',
    201: 'links(s)',
    103: 'KWS',
    400: 'value'
  },
  targetType: {
    Custom: 0,
    KeywordsTotal: 100,
    KeywordsAdded: 101,
    KeywordsInTop: 102,
    KeywordsInTopIncrease: 103,
    LinksTotal: 200,
    LinksAdded: 201,
    Kvr: 300,
    KvrIncrease: 301,
    UniqueUrls: 310,
    UniqueUrlsIncrease: 311,
    AverageKeywordsRank: 320,
    AverageKeywordsRankIncrease: 321,
    OrganicTrafficValue: 400
  },
  state: {
    IN_PROGRESS: 0,
    COMPLETED: 1,
    FAILED: 2,
    DISABLED: 3,
    PENDING_USER_UPDATE: 4,
    PENDING_RECURRING: 5
  },
  allStatesSelect: [
    { text: 'All', value: '' },
    { text: 'In progress', value: 0 },
    { text: 'Completed', value: 1 },
    { text: 'Failed', value: 2 },
    { text: 'Disabled', value: 3 },
    { text: 'Pending user update', value: 4 },
    { text: 'Pending recurring', value: 5 }
  ],
  stateSelect: [
    { text: 'All', value: '' },
    { text: 'In progress', value: 0 },
    { text: 'Completed', value: 1 },
    { text: 'Failed', value: 2 }
    // { text: 'Disabled', value: 3 }
    // { text: 'Pending user update', value: 4 },
    // { text: 'Pending recurring', value: 5 }
  ],
  stateSelectForCustom: [
    // { text: 'In progress', value: 0 },
    { text: 'Completed', value: 1 },
    { text: 'Failed', value: 2 }
  ]
}



// WEBPACK FOOTER //
// ./src/store/goal/state.js